import React from 'react';
import { Icon } from '@trustedshops/tps-seo-shared-frontend-react-components';
import {
  CategoryOpener as CategoryOpenerStyled,
  CategoryOpenerText
} from './CategoryOpener.styles';
import { CategoryOpenerProps } from 'models/CategoryOpenerProps';
import { FormattedMessage } from 'react-intl';
import { iconVariables } from 'styles/icon.variables';

const CategoryOpener = ({ setModalVisible, category }: CategoryOpenerProps) => (
  <CategoryOpenerStyled
    onClick={/* istanbul ignore next */ () => setModalVisible('categories')}
  >
    <CategoryOpenerText $categorySet={!!category}>
      {category || <FormattedMessage id={'CATEGORIES'} />}
    </CategoryOpenerText>
    <Icon
      iconName="icon-arrow-chevron-right"
      iconSize={iconVariables.SIZE_L}
      lineHeight={iconVariables.LINE_HEIGHT_REGULAR}
    />
  </CategoryOpenerStyled>
);

export default CategoryOpener;
